/**
 * Catalog facility labels (EN + HE) the assistant can hard-filter by.
 * Icons come from {@link facilityAddonIconId} — keep labels aligned with
 * GET `/assets/facilities` and the Transportation / Accessibility create section.
 */
export const ASSISTANT_FACILITY_AMENITY_LABELS: readonly string[] = [
  // Connectivity / access
  'Wi-Fi',
  'High-Speed Internet',
  'Wireless Internet',
  'Internet',
  'אינטרנט',
  'אינטרנט מהיר',
  'אינטרנט אלחוטי',
  'ווייפיי',
  '24/7 Access',
  'גישה 24/7',
  // Kitchen / cafe
  'Kitchen',
  'Kitchenette',
  'מטבח',
  'מטבחון',
  'Coffee Machine',
  'Coffee',
  'מכונת קפה',
  'קפה',
  'קפיטריה',
  'Microwave',
  'מיקרוגל',
  'Fridge',
  'Refrigerator',
  'מקרר',
  'Dishwasher',
  'מדיח',
  'מדיח כלים',
  'Water Cooler',
  'בר מים',
  'Snacks and Beverages',
  'חטיפים ומשקאות',
  'כיבוד',
  // Climate / comfort
  'Air Conditioning',
  'AC',
  'A/C',
  'מיזוג',
  'מיזוג אוויר',
  'Heating',
  'חימום',
  'Air Purifier',
  'מטהר אוויר',
  'Natural Light',
  'תאורה טבעית',
  // Rooms / work
  'Meeting Room',
  'Meeting Rooms',
  'חדר ישיבות',
  'חדרי ישיבות',
  'Conference Room',
  'חדר כנסים',
  'Reception',
  'קבלה',
  'Lounge',
  'Lounge Area',
  'לונג',
  'אזור לונג',
  'Break Room',
  'Waiting Area',
  'חדר מנוחה',
  'אזור המתנה',
  'Phone Booth',
  'תא טלפון',
  'Standing Desk',
  'שולחן עמידה',
  'Video Conferencing',
  'Zoom',
  'ועידת וידאו',
  'זום',
  // AV / office gear
  'Projector',
  'מקרן',
  'Whiteboard',
  'לוח מחיק',
  'Printer',
  'מדפסת',
  'Scanner',
  'סורק',
  'TV',
  'Television',
  'טלוויזיה',
  'Bookshelves',
  'Bookshelf',
  'מדפי ספרים',
  'מדף ספרים',
  // Storage / lockers
  'Storage',
  'Storage Shelves',
  'Storage Shelf',
  'אחסון',
  'מדפי אחסון',
  'Private Storage',
  'אחסון פרטי',
  'Lockers',
  'Locker',
  'Locker Room',
  'לוקר',
  'לוקרים',
  'חדר הלבשה',
  // Fitness / wellness
  'Gym',
  'Gym Access',
  'Fitness Room',
  'Fitness Center',
  'חדר כושר',
  'מרכז כושר',
  'Swimming Pool',
  'Pool',
  'בריכה',
  'בריכת שחייה',
  'Shower',
  'Showers',
  'Shower Facilities',
  'Sauna',
  'מקלחת',
  'מקלחות',
  'מתקני מקלחות',
  'סאונה',
  'Pilates',
  'פילאטיס',
  'Yoga',
  'יוגה',
  'Weights',
  'Dumbbell',
  'משקולות',
  // Safety / building
  'Protected Space',
  'מרחב מוגן',
  'מקלט',
  'Security',
  'CCTV',
  'אבטחה',
  'מצלמות אבטחה',
  'Elevator',
  'Lift',
  'מעלית',
  'Restroom',
  'Bathroom',
  'Toilet',
  'שירותים',
  'Soundproofing',
  'Soundproof',
  'בידוד אקוסטי',
  'Dedicated IT Support',
  'IT Support',
  'תמיכה IT',
  'מחשוב',
  'On-site Maintenance',
  'Maintenance',
  'תחזוקה',
  // Pets / family
  'Pet Friendly',
  'Pet-Friendly',
  'ידידותי לחיות',
  'ידידותי לחיות מחמד',
  'Childcare',
  'Daycare',
  'מעון',
  // Outdoor
  'Balcony',
  'Terrace',
  'Garden',
  'מרפסת',
  'טרסה',
  'גינה',
  // Transportation and Accessibility (create section)
  'Handicap Accessible',
  'Wheelchair Accessible',
  'Wheelchair Access',
  'Accessibility',
  'Accessible Entrance',
  'נגישות',
  'נגיש לנכים',
  'נגישות לכיסא גלגלים',
  'Close to public transportation',
  'Public Transportation',
  'Close to Bus',
  'Close to Train',
  'Near Bus',
  'Near Train',
  'Bus Stop',
  'Train Station',
  'תחבורה ציבורית',
  'קרוב לתחבורה ציבורית',
  'קרוב לתחבורה',
  'קרוב לאוטובוס',
  'קרוב לרכבת',
  'תחנת אוטובוס',
  'תחנת רכבת',
  'Free Parking',
  'Paid Parking',
  'Parking',
  'Car Park',
  'חניה',
  'חניה חינם',
  'חניה בתשלום',
  'פרקינג',
  'Electric Car Charging',
  'EV Charging',
  'טעינת רכב חשמלי',
  'עמדת טעינה',
  'Bicycle Storage',
  'Bike Storage',
  'אחסון אופניים',
  'חניות אופניים',
];
